module.exports = __webpack_public_path__ + "img/transfer_money.32a25fb2.svg";